// import Player from '@vimeo/player'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'
import 'videojs-youtube/dist/Youtube.min.js'
import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.cjs'

const state = {
  player: null,
  isLoaded: false,
  isBuffering: false,
  status: 'STOPPED',
  videoId: null,
  provider: 'vimeo',
}

const getters = {
  player: ({ player }) => player,

  isPlayerPaused: ({ status }) => status === 'PAUSED',

  isPlayerStopped: ({ status }) => status === 'STOPPED',

  isPlayerPlaying: ({ status }) => status === 'PLAYING',

  isPlayerEnded: ({ status }) => status === 'ENDED',

  isPlayerLoaded: ({ isLoaded }) => isLoaded,

  isPlayerBuffering: ({ isBuffering }) => isBuffering,

  src: ({ provider, videoId }) => {
    const providers = {
      vimeo: `https://vimeo.com/${videoId}`,
      youtube: `https://www.youtube.com/watch?v=${videoId}`,
    }

    return { type: `video/${provider}`, src: providers[provider] }
  }
}

const mutations = {
  setPlayer: (state, player) => state.player = player,

  setStatus: (state, status) => state.status = status,

  setIsBuffering: (state, status) => state.isBuffering = status,

  setIsLoaded: (state, isLoaded) => state.isLoaded = isLoaded,
}

const actions = {
  async loadPlayer ({ commit, state, dispatch, getters }, { id, provider }) {
    await dispatch('destroyPlayer')

    state.videoId = id
    state.provider = provider

    
    const player = videojs(document.getElementById('player'), {
      vimeo: { "color": "#ff8000" },
      youtube: { ytControls: 2 }
    })
    
    player.tech(provider)
    player.src(getters.src)
    
    commit('setPlayer', player)
    commit('setIsLoaded', true)

    state.player.on('play', () => commit('setStatus', 'PLAYING'))

    state.player.on('pause', () => commit('setStatus', 'PAUSED'))

    state.player.on('ended', () => commit('setStatus', 'ENDED'))
  },

  async destroyPlayer ({ commit, getters }) {
    if (!getters.player) return null

    await getters.player.reset()

    commit('setPlayer', null)
    commit('setIsLoaded', false)
    commit('setIsBuffering', false)
    commit('setStatus', 'STOPPED')
  },

  pausePlayer ({ getters }) {
    getters.player.pause()
  },

  playPlayer ({ getters, commit }) {
    getters.player.play()
    commit('setStatus', 'PLAYING')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
